import { render, staticRenderFns } from "./CustomerAccountDetail.vue?vue&type=template&id=4086b4f4&"
import script from "./CustomerAccountDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerAccountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports